// Libraries
import {
  OnInit,
  OnChanges,
  SimpleChange,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import {
  FormGroup
}  from '@angular/forms';
import * as _ from 'lodash';

/**
 * `Filterable` implements a concern to manage filters.
 */
export abstract class Filterable implements OnInit, OnChanges {
  /**
   * From group for filter object.
   */
  public form: FormGroup;
  /**
   * Disable or enable all form controls.
   */
  @Input() disabled = false;
  /**
   * An expression that is called when the form has been changed.
   */
  @Output() filter: EventEmitter<any> = new EventEmitter();
  /**
   * Debounce time to trigger filter event.
   */
  protected debounceTime = 500;

  /**
   * Implements on init method.
   */
  public ngOnInit(): void {
    this.form = this.buildForm();
    this.bindForm();
  }

  /**
   * Implements on changes method for input values.
   */
  public ngOnChanges(changes: {[propKey: string]: SimpleChange}) {
    // If disabled input value is changed, init form again
    if (changes.disabled.currentValue !==  changes.disabled.previousValue) {
      this.onChangeDisabled();
    }
  }

  /**
   * Create form group object
   */
  protected abstract buildForm(): FormGroup

  /**
   * Prepare filter to emit filter event.
   * @param data Form data
   */
  protected abstract prepareFilters(data: any): any

  /**
   * Handles disabled input changes
   */
  protected onChangeDisabled(): void {
  }

  /**
   * Handles form data changes.
   * @param data New data
   */
  protected onValueChanged(data: any): void {
    this.onFilter(data);
  }

  /**
   * Handles generic form control data changes.
   * @param data New data
   */
  protected onGenericValueChanged(formControlName: string, value: any): void {
    let control = this.form.get(formControlName);
    // Check if is disabled
    if (control.disabled) {
      return;
    }
    // Partial filter
    let filter = {};
    filter[formControlName] = value;
    // Partial filter
    this.onPartialFilter(filter);
  }

  /**
   * Bind value changes event.
   */
  protected bindForm() {
    // Subscribe to form changes
    this.form.valueChanges
      .subscribe(data => this.onValueChanged(data));
  }

  /**
   * Make filters.
   * @param data Filters
   */
  protected onFilter(data: any): void {
    let filters = this.prepareFilters(data);
    // Filter filters
    filters = _.pickBy(filters, (filter) => {
      // Filter only numbers, arrays, booleans and not empty strings
      return _.isNumber(filter) || _.isArray(filter) || _.isBoolean(filter) || (_.isString(filter) && !_.isEmpty(filter));
    });
    // Emit filter event
    this.filter.emit(filters);
  }

  /**
   * Make partial filters.
   * @param data Partial filters
   */
  protected onPartialFilter(data: any) {
    let filters = _.merge(this.form.value, data);
    // Execute filter
    this.onFilter(filters);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/woopa-ui/filter/filterable.ts